module.exports = __webpack_public_path__ + "img/25.c20549fa.png";